document.addEventListener('DOMContentLoaded', () => {
  const menuButton = document.querySelector('[data-menu-toggle]');
  const mobileMenu = document.querySelector('[data-mobile-menu]');

  if (menuButton && mobileMenu) {
    menuButton.addEventListener('click', () => {
      const isOpen = menuButton.getAttribute('aria-expanded') === 'true';
      menuButton.setAttribute('aria-expanded', String(!isOpen));
      mobileMenu.hidden = isOpen;
      document.body.classList.toggle('menu-open', !isOpen);
    });
    document.addEventListener('keydown', event => { if(event.key === 'Escape' && !mobileMenu.hidden) { mobileMenu.hidden=true; menuButton.setAttribute('aria-expanded','false'); document.body.classList.remove('menu-open'); menuButton.focus(); } });
    mobileMenu.querySelectorAll('a').forEach(a => a.addEventListener('click', () => {mobileMenu.hidden=true;menuButton.setAttribute('aria-expanded','false');document.body.classList.remove('menu-open');}));
  }

  document.querySelectorAll('[data-variant-select]').forEach((select) => {
    select.addEventListener('change', (event) => {
      const option = event.target.options[event.target.selectedIndex];
      const form = event.target.closest('form');
      const button = form ? form.querySelector('[data-add-to-cart]') : null;
      const price = document.querySelector('[data-product-price]');

      if (button) {
        const available = option.dataset.available === 'true';
        button.disabled = !available;
        button.textContent = available ? button.dataset.addLabel : button.dataset.soldLabel;
      }

      const priceTemplate = document.querySelector('[data-variant-price="' + option.value + '"]');
      if (price && priceTemplate) price.replaceChildren(priceTemplate.content.cloneNode(true));
      const url = new URL(window.location.href); url.searchParams.set('variant', option.value); history.replaceState({}, '', url);
    });
  });

  document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
    const viewport = gallery.querySelector('[data-gallery-viewport]');
    const slides = Array.from(gallery.querySelectorAll('[data-gallery-slide]'));
    const thumbnails = Array.from(gallery.querySelectorAll('[data-gallery-thumbnail]'));
    const previous = gallery.querySelector('[data-gallery-previous]');
    const next = gallery.querySelector('[data-gallery-next]');
    let currentIndex = 0;
    let scrollFrame;

    if (!viewport || slides.length < 2) return;

    const updateGallery = (index) => {
      currentIndex = Math.max(0, Math.min(index, slides.length - 1));
      thumbnails.forEach((thumbnail, thumbnailIndex) => {
        const isActive = thumbnailIndex === currentIndex;
        thumbnail.classList.toggle('is-active', isActive);
        thumbnail.setAttribute('aria-current', String(isActive));
      });
      if (previous) previous.disabled = currentIndex === 0;
      if (next) next.disabled = currentIndex === slides.length - 1;
    };

    const showSlide = (index) => {
      const targetIndex = Math.max(0, Math.min(index, slides.length - 1));
      viewport.scrollTo({ left: targetIndex * viewport.clientWidth, behavior: 'smooth' });
      updateGallery(targetIndex);
    };

    thumbnails.forEach((thumbnail) => {
      thumbnail.addEventListener('click', () => showSlide(Number(thumbnail.dataset.index)));
    });
    if (previous) previous.addEventListener('click', () => showSlide(currentIndex - 1));
    if (next) next.addEventListener('click', () => showSlide(currentIndex + 1));

    viewport.addEventListener('scroll', () => {
      cancelAnimationFrame(scrollFrame);
      scrollFrame = requestAnimationFrame(() => {
        const index = Math.round(viewport.scrollLeft / viewport.clientWidth);
        updateGallery(index);
      });
    }, { passive: true });

    updateGallery(0);
  });
});

 document.addEventListener('click', (event) => { const button=event.target.closest('[data-announcement-pause]'); if(!button)return; const announcement=button.closest('.announcement'); const paused=announcement.classList.toggle('announcement--paused'); button.setAttribute('aria-pressed',String(paused)); button.setAttribute('aria-label',paused?'Play announcements':'Pause announcements'); button.textContent=paused?'▶':'Ⅱ'; });
